export const STRAPI_SECTION_IDS = {
  AUDITS: "security",
  ECOSYSTEM: "ecosystem",
  MEET: "meet",
  REWARDSCALCULATOR: "calculator",
  HOWITWORKS: "works",
  PARTNERS: "partners",
  SUBSCRIBE: "subscribe",
  COMMINITY: "community",
  BLOGS: "blogs",
  KNOWMORE: "know-more",
};

interface ObjectLiteral {
  [key: string]: any;
}

export const navItemEventMapping: ObjectLiteral = {
  [STRAPI_SECTION_IDS.MEET]: "view_meet",
  [STRAPI_SECTION_IDS.HOWITWORKS]: "view_how_it_works",
  [STRAPI_SECTION_IDS.ECOSYSTEM]: "view_ecosystem",
  [STRAPI_SECTION_IDS.REWARDSCALCULATOR]: "view_reward_calculator",
  [STRAPI_SECTION_IDS.AUDITS]: "view_security",
  [STRAPI_SECTION_IDS.PARTNERS]: "view_partners",
  [STRAPI_SECTION_IDS.COMMINITY]: "view_communities",
  [STRAPI_SECTION_IDS.SUBSCRIBE]: "view_newsletter",
};
